import Nullstack from 'nullstack';
export default function IconStorm({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-storm",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "7"
  }), "   ", Nullstack.element("path", {
    d: "M5.369 14.236c-1.839 -3.929 -1.561 -7.616 -.704 -11.236"
  }), "   ", Nullstack.element("path", {
    d: "M18.63 9.76c1.837 3.928 1.561 7.615 .703 11.236"
  }), " ");
}